import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://123cambodia.newgads.com/api';

const api = axios.create({
  baseURL: API_BASE,
});

// Auto-attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) => {
  const form = new FormData();
  form.append('username', username);
  form.append('password', password);
  return api.post('/auth/login', form);
};

export const getMe = () => api.get('/auth/me');

// Dashboard
export const getDashboard = () => api.get('/reports/dashboard');
export const getQueueSummary = () => api.get('/orders/queues/summary');

// Customers
export const getCustomers = (params) => api.get('/customers/', { params });
export const getCustomer = (id) => api.get(`/customers/${id}`);
export const createCustomer = (data) => api.post('/customers/', data);
export const updateCustomer = (id, data) => api.put(`/customers/${id}`, data);
export const addCustomerNote = (id, note) => api.post(`/customers/${id}/notes`, { note });
export const getCustomerOrders = (id) => api.get(`/customers/${id}/orders`);
export const requestMerge = (a, b, reason) => api.post('/customers/merge-request', null, { params: { customer_id_a: a, customer_id_b: b, reason } });

// Products
export const getProducts = () => api.get('/products');
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data);
export const adjustStock = (id, data) => api.post(`/products/${id}/stock/adjust`, data);

// Orders
export const getOrders = (params) => api.get('/orders', { params });
export const getOrder = (id) => api.get(`/orders/${id}`);
export const createOrder = (data) => api.post('/orders', data);
export const updateOrderStatus = (id, status, note) => api.put(`/orders/${id}/status`, { status, note });
export const updateOrderDelivery = (id, data) => api.put(`/orders/${id}/delivery`, data);
export const getOrderBill = (id) => api.get(`/orders/${id}/bill`);

// Followup
export const getFollowups = () => api.get('/followup');

// Payments
export const getPayments = () => api.get('/payments');

// Customer ranking
export const updateCustomerRanking = (id, data) => api.put(`/customers/${id}/ranking`, data);

// Live comment processed
export const markCommentProcessed = (sessionId, commentId) => 
  api.post(`/live/sessions/${sessionId}/comments/${commentId}/process`);

export default api;